/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addMediaPartnerAdvertiser} from '../api'

export const useMutationAddMediaPartnerAdvertiser = createReactQueryMutationHook('addMediaPartnerAdvertiser', addMediaPartnerAdvertiser)
